// extracted by mini-css-extract-plugin
export default {"header":"BaseContainer_header__wDNKo","search":"BaseContainer_search__ga44p"};